import { EffectCallback, useEffect } from 'react';

/**
 * Hook that runs a function only on mount
 *
 * @param effect function to run on mount
 */
export default function useEffectOnce(effect: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
}
